var siteConfig = {
  baseStnQth:   "CN85qm",
  callSign:     "K7JLX",
  hamName:      "Josh Lucy",
  hamLocation:  "Portland, OR",
  licenseClass: "General"
};

export default siteConfig;